import { getHostName, convertToUTC } from "../utils";
import { cachedGet } from "./requestCache.js";

export async function fetchRocketFamilies() {
  return cachedGet("rocketfamilies", async () => {
    const data = await fetch(`${getHostName()}/api/rocketfamilies/?format=json`);
    return data.json();
  });
}

export async function fetchRockets() {
  return cachedGet("rockets", async () => {
    const data = await fetch(`${getHostName()}/api/rockets/?format=json`);
    return data.json();
  });
}

export async function fetchFamilyInfo(family, startDate) {
  const dateKey = startDate ? convertToUTC(startDate) : "";
  return cachedGet(`familyinfo:${family}:${dateKey}`, async () => {
    const data = await fetch(
      `${getHostName()}/api/familyinformation/?family=${family}${
        dateKey ? `&startdate=${dateKey}` : ""
      }&format=json`
    );
    return data.json();
  });
}
